import { artistHref } from '@/features/artists/artistHref'
import { ListPlus, Trash2 } from 'lucide-react'
import { usePlayer } from '@/audio/store'
import { TrackRow } from '@/components/TrackRow'
import { SwipeSurface } from './SwipeSurface'
import { enqueueWithUndo, queueSongKey, useQueueFeedback } from './queueGestureActions'

export function QueueHistory() {
  const queue = usePlayer((state) => state.queue)
  const index = usePlayer((state) => state.index)
  const session = usePlayer((state) => state.session)
  const pending = useQueueFeedback((state) => state.pending)
  const played = index > 0 ? queue.slice(0, index) : []
  if (!played.length) return null
  const identity = `${session}:${index}:${queue.map((item) => item.uid).join(',')}`
  return <details className="mt-5 border-t border-border pt-3" data-gesture-ignore>
    <summary className="min-h-11 cursor-pointer px-2 py-3 text-sm font-medium text-text-muted">Played · {played.length}</summary>
    <ul className="flex flex-col gap-1">{played.map((item, position) => {
      const busy = pending.includes(queueSongKey(item))
      return <li key={item.uid}>
        <SwipeSurface identity={identity} right={busy ? 'Preparing…' : 'Add to queue'} onRight={busy ? undefined : () => enqueueWithUndo(item)}>
          <TrackRow title={item.title} artistName={item.artistName} artistHref={artistHref({ local_artist_id: item.localArtistId, artist_id: item.artistId })} albumName={item.albumName} coverUrl={item.coverUrl} durationMs={item.durationMs} onPlay={() => usePlayer.getState().playAt(position)} includeArtistMenu={false} menuItems={[
            { label: 'Add to queue', icon: ListPlus, disabled: busy, onSelect: () => enqueueWithUndo(item) },
            { label: 'Remove from queue', icon: Trash2, destructive: true, onSelect: () => usePlayer.getState().removeAt(position) },
          ]} />
        </SwipeSurface>
      </li>
    })}</ul>
  </details>
}
